import React, { useState } from 'react';
import CardProducto from '../Components/CardProducto';
import { productos } from '../data/productos';
import { Producto } from '../types';

const Productos: React.FC = () => {
  const [filtro, setFiltro] = useState<string>('todos');
  
  const productosFiltrados: Producto[] = productos.filter((producto: Producto) => {
    if (filtro === 'todos') return true;
    return producto.categoria === filtro;
  });

  return (
    <div className="page">
      <div className="container">
        <div className="products-header">
          <h3 className="section-title">Nuestros Productos</h3>
          <p className="section-subtitle">Descubre nuestra deliciosa selección de postres y cafés</p>
          
          <div className="filter-buttons">
            <button
              className={`filter-btn ${filtro === 'todos' ? 'active' : ''}`}
              onClick={() => setFiltro('todos')}
            >
              Todos
            </button>
            <button
              className={`filter-btn ${filtro === 'cafe' ? 'active' : ''}`}
              onClick={() => setFiltro('cafe')}
            >
              ☕ Cafés
            </button>
            <button
              className={`filter-btn ${filtro === 'postre' ? 'active' : ''}`}
              onClick={() => setFiltro('postre')}
            >
              🍰 Postres
            </button>
          </div>
        </div>
        
        <div className="products-grid">
          {productosFiltrados.map((producto: Producto) => (
            <CardProducto key={producto.id} {...producto} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Productos;